import { useValidateEmail } from '@/hooks'

import { Texts } from '../../../../hooks/useTexts'

export const createValidateCompanyEmail = async (
  texts: Texts,
  email: string,
  validateEmail: ReturnType<typeof useValidateEmail>,
) => {
  const companyEmailInvalid = {
    id: 'companyEmailInvalid',
    field: 'companyEmail',
    message: texts.validations.companyEmailInvalidFormat,
  }

  const empty = email.trim().length === 0

  const valid = empty ? true : await validateEmail(email)

  return {
    [companyEmailInvalid.id]: !valid ? companyEmailInvalid : undefined,
  }
}
